<div *ngIf="!addFlag">
  <form [formGroup]="_mFormGroup">
    <div class="row mt-3">
      <div class="col-sm-3">
        <label>Location<sup class="mandatory">*</sup></label>
        <select class="form-select" placeholder="City" formControlName="city" (change)="getSitesByCityId()" required>
          <option disabled value="">Choose Location</option>
          <option *ngFor="let city of _mCities" [value]="city.locationId">
            {{ city.locationName }}
          </option>
        </select>
        <div class="error-msg" *ngIf="_mFormGroup.get('city').hasError('required') && _mFormGroup.get('city').touched">
          Please select city
        </div>
      </div>
      <div class="col-sm-3">
        <label>Site<sup class="mandatory">*</sup></label>
        <select class="form-select" placeholder="Site" formControlName="site" required>
          <option disabled value="">Choose Site</option>
          <option *ngFor="let site of _mSites" [value]="site.siteId">
            {{ site.siteName}}
          </option>
        </select>
        <div class="error-msg" *ngIf="_mFormGroup.get('site').hasError('required') && _mFormGroup.get('site').touched">
          Please select site
        </div>
      </div>
      <div class="col-sm-3">
        <label>Route type<sup class="mandatory">*</sup></label>
        <select class="form-select" placeholder="Select RouteType" formControlName="routeType" required>
          <option disabled value="">Choose Route type</option>
          <option *ngFor="let routeType of _mRouteTypes" [value]="routeType.key">
            {{ routeType.value}}
          </option>
        </select>
        <div class="error-msg"
          *ngIf="_mFormGroup.get('routeType').hasError('required') && _mFormGroup.get('routeType').touched">
          Please select routeType
        </div>
      </div>
      <div class="col-sm-3 d-flex justify-content-end" style="margin-top: 25px">
        <button type="button" [disabled]="_mFormGroup.invalid" style="height: 35px;" class="btn fr-btn-solid"
          (click)="onSubmit()">
          Submit
        </button>
      </div>
    </div>
  </form>

  <div class="fixedRoutedHeading mt-3" style="padding:0px; height: 52px;">
    <div style="float: left; padding: 15px 0px 0px 15px; font-size: 14px; font-weight: 500; font-family: 'poppins';">
      Route
      List</div>
    <span style="font-size: 14px; font-weight: 500; font-family: 'poppins';" (click)="onDownloadHAL()">Download
      H-AL</span>
    <span style="font-size: 14px; font-weight: 500; font-family: 'poppins';" (click)="onDownloadAL()">Download
      C-AL</span>
    <span style="font-size: 14px; font-weight: 500; font-family: 'poppins';" (click)="downloadRouteTemplate()">Download
      Route Template</span>
    <span style="font-size: 14px; font-weight: 500; font-family: 'poppins';" (click)="downloadRoutes()">Download Routes
      Download</span>
    <label style="font-size: 14px; font-weight: 500; font-family: 'poppins';">Upload<input class="tdw-display-none"
        (change)="onFileChange($event)" [ngModelOptions]="{standalone: true}" [(ngModel)]="routesFile"
        type="file"></label>
    <span style="font-size: 14px; font-weight: 500; font-family: 'poppins';" (click)="onAdd()">Add</span>
  </div>

  <div class="fixedRouted_total_list">
    <div class="row">
      <div class="col-md-3 no-padding" style="padding-left:14px !important;">
        <div class="fr_inner_div">
          <div class="fr_header">
            <label class="fixroute-label">Search route</label>
            <mat-form-field appearance="outline" class="fixed-route-date">
              <input matInput placeholder="Search" [(ngModel)]="mRouteSearchKey" autocomplete="off"
                (input)="routeSearch($event)">
              <img matSuffix src="assets/images/search.svg" height="27" style="margin-top: -22px;padding-right: 5px;">
            </mat-form-field>
          </div>
          <ul class="fr_route_list">
            <ng-container *ngIf="_mRoutesData.length > 0; else noData">
              <li class="main_li fix-route-td" (mouseover)="hoverFunction($event)" (click)="getAreaByRouteId(route.id)"
                (mouseout)="hoverOutFunction($event)" *ngFor="let route of
              _mRoutesData">{{route.routeName}}
                <span *ngIf="(route.routeType == 'P') ? true : false" class="fr_Primary">Primary</span>
                <span *ngIf="(route.routeType == 'C') ? true : false" class="fr_combaind">Combined</span>
                <span *ngIf="(route.routeType == 'FC') ? true : false" class="fr_fully_combaind">Fully Combined</span>
                <div>
                  <ul class="fr_list_icons">
                    <li><mat-icon matSuffix (click)="onDelete(route,'route')">delete</mat-icon></li>
                  </ul>
                </div>
              </li>
            </ng-container>
            <ng-template #noData>
              <h4 class="tdw-text-align-center tdw-font-normal tdw-margin-4
              mat-color-text--blue-grey-600">-- No Data Found --</h4>
            </ng-template>
          </ul>
        </div>
      </div>
      <div class="col-md-2 no-padding">
        <div class="fr_inner_div">
          <div class="fr_header">
            <label class="fixroute-label">Search Area</label>
            <mat-form-field appearance="outline" class="fixed-route-date">
              <input matInput placeholder="Search" [(ngModel)]="mAreaSearchKey" autocomplete="off"
                (input)="areaSearch($event)">
              <img matSuffix src="assets/images/search.svg" height="27" style="margin-top: -22px;padding-right: 5px;">
            </mat-form-field>
          </div>
          <ul class="fr_route_list">
            <ng-container *ngIf="_mAreasData.length > 0; else noData">
              <li class="main_li fix-route-td" (mouseover)="hoverFunction($event)"
                (click)="getLandmarkByAreaId(area.id)" (mouseout)="hoverOutFunction($event)" *ngFor="let area of
              _mAreasData">{{area.area}}
                <div>
                  <ul class="fr_list_icons">
                    <li><mat-icon matSuffix (click)="onDelete(area,'area')">delete</mat-icon></li>
                  </ul>
                </div>
              </li>
            </ng-container>
            <ng-template #noData>
              <h4 class="tdw-text-align-center tdw-font-normal tdw-margin-4
              mat-color-text--blue-grey-600">-- No Data Found --</h4>
            </ng-template>
          </ul>
        </div>
      </div>
      <div class="col-md-7">
        <div class="fr_header">
          <label class="fixroute-label">Search Landmark</label>
          <mat-form-field appearance="outline" class="fixed-route-date">
            <input matInput placeholder="Search by landmark" [(ngModel)]="mLandmarkSearchKey" autocomplete="off"
              (input)="landmarkSearch($event)">
            <img matSuffix src="assets/images/search.svg" height="27" style="margin-top: -22px;padding-right: 5px;">
          </mat-form-field>
        </div>
        <div class="fr_route_list">
          <table mat-table [dataSource]="dataSource" class="fixedRouteTable" *ngIf="ELEMENT_DATA.length > 0;">
            <ng-container matColumnDef="landmark">
              <th mat-header-cell *matHeaderCellDef class="fix-route-th">Landmark</th>
              <td mat-cell *matCellDef="let element" class="fr-padding fix-route-td">
                {{element.landmark}} </td>
            </ng-container>
            <ng-container matColumnDef="latitude">
              <th mat-header-cell *matHeaderCellDef class="fix-route-th"> Latitude </th>
              <td mat-cell *matCellDef="let element" class="fix-route-td"> {{element.latitude}} </td>
            </ng-container>
            <ng-container matColumnDef="longitude">
              <th mat-header-cell *matHeaderCellDef class="fix-route-th"> Longitude </th>
              <td mat-cell *matCellDef="let element" class="fix-route-td"> {{element.longitude}}
              </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef class="fix-route-th">Type </th>
              <td mat-cell *matCellDef="let element" class="fix-route-td"> {{element.type}} </td>
            </ng-container>
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef class="fix-route-th">Action</th>
              <td mat-cell class="table_delete_FixedRoute" *matCellDef="let element">
                <mat-icon (click)="onDelete(element,'landmark')" matSuffix>delete</mat-icon>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="row" *ngIf="ELEMENT_DATA.length == 0">
            <div class="col-sm-12 col-md-12">
              <h4 class="tdw-text-align-center tdw-font-normal tdw-margin-4
                  mat-color-text--blue-grey-600">
                --No Data Found --</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="addFlag">
  <app-add-fixed-routing [routingData]="routingData"></app-add-fixed-routing>
</div>